/**
 * Cave's logo: a bottle of red wine with its label (owner request, 2026-09-28). Decorative only:
 * the page's heading names the app, so the drawing is hidden from screen readers.
 */
export function WineBottleLogo({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 128"
      width="64"
      height="128"
      aria-hidden="true"
      focusable="false"
    >
      {/* Capsule */}
      <rect x="25" y="4" width="14" height="18" rx="2" fill="#c9a24a" />
      {/* Bottle: neck, shoulders, body */}
      <path
        d="M27 22h10v18c0 6 13 12 13 26v52a6 6 0 0 1-6 6H20a6 6 0 0 1-6-6V66c0-14 13-20 13-26z"
        fill="#5a0f2e"
        stroke="#f4e3ea"
        strokeWidth="2"
      />
      {/* Wine level */}
      <path d="M16 80h32v38a4 4 0 0 1-4 4H20a4 4 0 0 1-4-4z" fill="#8e1b3f" />
      {/* Label */}
      <rect x="18" y="72" width="28" height="26" rx="2" fill="#f4e3ea" />
      <path d="M24 82h16M26 88h12" stroke="#5a0f2e" strokeWidth="2" strokeLinecap="round" />
      {/* Highlight */}
      <path
        d="M21 60c0-6 4-10 8-13"
        stroke="#f4e3ea"
        strokeOpacity="0.45"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
}
